<template>
  <div class="evaluation-top-bar">
    <div class="right-wrapper">
      <div class="navigation-controls">
        <button
          class=""
          @click="$emit('partial-save')"
        >
          Guardar Avance
        </button>
        <button
          :disabled="prevDisabled"
          @click="$emit('previous')"
        >
          <i class="icon-navigate_before" /> Anterior
        </button>
        <button
          v-if="showNext"
          :disabled="nextDisabled"
          @click="$emit('next')"
        >
          Siguiente
          <i class="icon-navigate_next" />
        </button>
        <button
          v-else
          @click="$emit('save')"
        >
          Finalizar
          <i class="icon-navigate_next" />
        </button>
      </div>
    </div>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
export default {
  name: 'EvaluationTopBar',
  components: {},
  props: {
    currentSectionIndex: {
      type: Number,
      default: 0
    },
    sectionsCount: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data () {
    return {}
  },
  computed: {
    showNext () {
      console.log(this.currentSectionIndex, ' vs ', this.sectionsCount - 1)
      return this.currentSectionIndex < this.sectionsCount - 1
    },
    nextDisabled () {
      return this.currentSectionIndex === this.sectionsCount - 1
    },
    prevDisabled () {
      return this.currentSectionIndex <= 0
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.evaluation-top-bar {
  height: 50px;
  border-bottom: 1px solid #dddddd;
  display: flex;
  overflow: hidden;
  align-content: stretch;
  justify-content: flex-start;
  button {
    display: inline-block;
    background-color: transparent;
    border: none;
    font-size: 16px;
    padding: 10px;
    height: 50px;
    line-height: 20px;
    color: #666666;
    &:disabled {
      color: #999999;
    }
    &.button-primary {
      background-color: $color-ui-primary;
      color: #fff;
    }
  }
  .right-wrapper {
    text-align: right;
    width: 100%;
    display: flex;
    .evidence-controls {
      border-left: 1px solid #dddddd;
      display: inline-block;
    }
    .navigation-controls {
      display: block;
      width: 100%;
      button {
        border-left: 1px solid #dddddd;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/layout/evaluation-top-bar.vue